// File: components/DutyList/ExportButtons.js
import React from "react";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import html2canvas from "html2canvas";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import logoLeft from "../../assets/img/logo/new-logo.png";
import logoRight from "../../assets/img/logo/punjab-logo.png";

const ExportButtons = ({
  selectedRoles,
  filtered,
  fireTeam,
  fileDate,
  readableDate,
  urduData,
  loading,
  printRef,
  tableRef
}) => {
  const exportToPDF = () => {
    const doc = new jsPDF({ orientation: "landscape" });
    const pageWidth = doc.internal.pageSize.getWidth();
    const imgLeft = new Image();
    const imgRight = new Image();

    imgLeft.src = logoLeft;
    imgRight.src = logoRight;

    const rolesToPrint = Object.keys(selectedRoles).filter((r) => selectedRoles[r]);
    let startY = 60;

    rolesToPrint.forEach((roleKey) => {
      const isFireTeam = roleKey === "FireFighting";
      let data = [];

      if (isFireTeam) {
        data = fireTeam
          .filter((d) => d.created_at === fileDate)
          .map((d) => ({ delegation: d.delegation, responsible: d.responsible }));
      } else {
        data = filtered
          .filter((d) => d.role.toLowerCase() === roleKey.toLowerCase())
          .map((d) => ({ on_call: d.on_call, name: d.name, contact: d.contact }));
      }

      if (data.length > 0) {
        autoTable(doc, {
          head: [["#", "On Call", "Doctor Name", "Contact"]],
          body: data.map((d, i) => [i + 1, d.on_call, d.name, d.contact]),
          startY,
          theme: "grid",
          headStyles: { fillColor: [0, 102, 204], textColor: 255, fontSize: 14, fontStyle: "bold", halign: "center" },
          bodyStyles: { fontSize: 10, textColor: [0, 0, 0], halign: "center" },
          margin: { top: 50 },
          didDrawPage: () => {
            doc.addImage(imgLeft, "PNG", 10, 15, 25, 22);
            doc.addImage(imgRight, "PNG", pageWidth - 35, 15, 25, 25);
            doc.setFontSize(28);
            doc.setFont("helvetica", "bold");
            doc.text("Rawalpindi Institute of Cardiology", pageWidth / 2, 25, { align: "center" });
            doc.setFontSize(11);
            doc.setFont("helvetica", "normal");
            doc.text("PART 1 (Evening / Night Duty Roster)", pageWidth / 2, 32, { align: "center" });
            doc.text(`(${readableDate})`, pageWidth / 2, 40, { align: "center" });
          },
        });

        startY = doc.lastAutoTable.finalY + 20;
      }
    });

    const pageCount = doc.internal.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      doc.setFontSize(9);
      doc.setTextColor(150);
      doc.text(`Page ${i} of ${pageCount}`, pageWidth / 2, doc.internal.pageSize.getHeight() - 10, { align: "center" });
    }

    doc.save(`Part-1-Duty-Roster-${fileDate}.pdf`);
  };

  const exportToExcel = () => {
    const wsData = [
      ["", "", "Rawalpindi Institute of Cardiology", ""],
      ["", "", "PART 1 (Evening / Night Duty Roster)", ""],
      ["", "", `(${readableDate})`, ""],
      [""],
      ["#", "On Call", "Doctor Name", "Contact"],
      ...filtered.map((d, i) => [i + 1, d.on_call, d.name, d.contact]),
    ];
    const ws = XLSX.utils.aoa_to_sheet(wsData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Duty Roster");
    const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    saveAs(new Blob([wbout], { type: "application/octet-stream" }), `Duty-Roaster-${fileDate}.xlsx`);
  };

  const exportToImage = async () => {
    const canvas = await html2canvas(tableRef.current);
    const link = document.createElement("a");
    link.href = canvas.toDataURL("image/webp");
    link.download = `Duty-Roaster-${fileDate}.jpg`;
    link.click();
  };

  return (
    <div className="d-flex justify-content-end gap-2 mb-3">
      <button className="btn btn-outline-danger btn-sm" onClick={exportToPDF} disabled={loading}>Export PDF</button>
      <button className="btn btn-outline-success btn-sm" onClick={exportToExcel} disabled={loading}>Export Excel</button>
      <button className="btn btn-outline-primary btn-sm" onClick={exportToImage} disabled={loading}>Export JPG</button>
    </div>
  );
};

export default ExportButtons;
